module.exports = __webpack_public_path__ + "static/media/alison-brie-win.f723b4eb.jpg";